import { render, staticRenderFns } from "./PasoUnoComponent.vue?vue&type=template&id=2533e740&scoped=true"
import script from "./PasoUnoComponent.vue?vue&type=script&lang=js"
export * from "./PasoUnoComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoUnoComponent.vue?vue&type=style&index=0&id=2533e740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533e740",
  null
  
)

export default component.exports